module.exports = __webpack_public_path__ + "static/img/bg6.b480db1e.webp";